import { AppUserRole } from "../types/roles";
import { useMeQuery } from "./me/useMe";

/**
 * DBからログインユーザー情報を取得する
 */
export const useLoginUser = () => {
  const query = useMeQuery();
  const user = query.data;
  const isSystemAdmin = user?.role === AppUserRole.SystemAdmin;
  const isTenantAdmin = user?.role === AppUserRole.TenantAdmin;
  const isSystemOrTenantAdmin = isSystemAdmin || isTenantAdmin;
  const isWorker = user?.role === AppUserRole.Worker;
  const isAssignedToBuilding = !!user?.currentBuilding;

  return {
    ...query,
    user,
    isWorker,
    isSystemAdmin,
    isTenantAdmin,
    isSystemOrTenantAdmin,
    isAssignedToBuilding,
  };
};
